import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryCodeTab,
} from '@/layout/state/state';
import SearchActions from '../containers/SearchActions';
import { closeSearch } from '../actions';
import SearchPanel from '../components/SearchPanel';

export default (urls, access) => ({
  ...tabTemplate('search', SearchPanel, urls, SearchActions),
  ...tabCloser('closeSearchTab', closeSearch),
  ...tabIcons('search'),
  access,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2]),
  order: 100,
});
